import React, { Suspense, useState, useEffect } from 'react';
import { Spin, Modal, Form, Row, Col, Input, message } from 'antd';
import { useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Switch, useLocation, useHistory } from 'react-router-dom';
import withAdminLayout from '../layout/withAdminLayout1';
import { BasicFormWrapper2 } from '../container/styled';
import { Button } from '../components/buttons/buttons';
import { getAxiosInstance } from '../Api/ApiConfig'
import { setUserData, clearUserData, } from '../redux/CrmReduxCalls/LocalDataReduxStore';
// import { setEditCall } from '../redux/CrmReduxCalls/EditNavCtrl';

const Admin = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [form] = Form.useForm();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('oauth');
    const [oldPass, setOldPass] = useState();
    const [newPass, setNewPass] = useState();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setOpen(true);
        }, 4000);

        return () => clearTimeout(timer); // Cleanup the timer on unmount
    }, []);
    const onSubmit = async () => {
        setLoading(true);
        const formData = {
            newPassword: newPass,
            // email: email
        }
        try {
            const response = await getAxiosInstance().post(`/findLicenseManagement/resetNewPassword/${email}`, formData);
            if (response.data.statusCode === 200) {
                const expirationDate = new Date().getTime();
                const expirationDays = expirationDate + (2 * 60 * 60 * 1000)
                localStorage.setItem("cxs_expiration", expirationDays);
                dispatch(setUserData({ role: response.data.data.role }));
                const data = await getAxiosInstance().get(`/findLicenseManagement/findLicenseManagement`)
                if (data.data.data.licenseManagerStatus) {
                    dispatch(setUserData({ status: data.data.data.licenseManagerStatus }));
                    message.success(response.data.message);
                    setOpen(false);
                    setLoading(true);
                    //   dispatch(setEditCall(false))
                    history.push('/');
                    window.location.reload()
                }
                else {
                    message.error("Your account is inactive, please contact your admin");
                    window.localStorage.removeItem('cxs_expiration');
                    window.localStorage.removeItem('cxs_lastActivityTime');
                    dispatch(clearUserData());
                }
                // }
            }
            else {
                message.error(response.data.message);
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                message.error(error.response.data.message);
            } else {
                message.error('Failed to reset password. Please try again');
            }
        }
    };
    return (
        <Switch>
            <Suspense
                fallback={
                    <div className="spin">
                        <Spin />
                    </div>
                }
            >
                <Modal
                    open={open}
                    title="Reset Password"
                    closable={false}
                    footer={[
                        <>
                            <Button size="small" htmlType="submit" className="button_colors" loading={loading} onClick={() => form.submit()}>
                                <FeatherIcon icon="save" className="text_iconspace" />
                                Submit
                            </Button>
                        </>
                    ]}
                >
                    <div className="user-info-form">
                        <BasicFormWrapper2>
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={(values) => onSubmit(values)} colon={false}>
                                <Row>
                                    <Col span={24} style={{ marginBottom: 15 }}>
                                        <Form.Item name="old" rules={[
                                            {
                                                required: true,
                                                message: 'Please enter new password'
                                            },
                                            {
                                                pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                                message: 'Password must be at least 8 characters long, contain an uppercase letter, a number, and a special character',
                                            }
                                        ]} label="Enter New Password">
                                            <Input.Password placeholder="Enter New Password" type="password" value={oldPass} onChange={(e) => setOldPass(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item name="new" rules={[
                                            {
                                                required: true,
                                                message: 'Please re-enter password'
                                            },
                                            {
                                                pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                                message: 'Password must be at least 8 characters long, contain an uppercase letter, a number, and a special character',
                                            }, {
                                                validator: (_, value) =>
                                                    value === oldPass
                                                        ? Promise.resolve()
                                                        : Promise.reject(new Error('Passwords do not match')),
                                            },
                                        ]} label="Re-enter Password">
                                            <Input.Password placeholder="Re-enter Password" type="password" value={newPass} onChange={(e) => setNewPass(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </BasicFormWrapper2>
                    </div>
                </Modal>
            </Suspense>
        </Switch>
    );
}

export default withAdminLayout(Admin);
